import { get, post } from "@/infra/rest";

// Types for API
export type ContinuousMonitoringAction = "notify_recipients";

export interface ContinuousMonitoringConfiguration {
  id: string;
  title: string;
  enabled: boolean;
  organization_id: string;
  email_recipients: string[];
  rules: string[];
  actions: ContinuousMonitoringAction[];
  monitoring_type: string;
  index: number;
}

export interface GetConfigurationsResponse {
  success: boolean;
  configurations: ContinuousMonitoringConfiguration[];
}

export interface UpdateConfigurationPayload {
  enabled: boolean;
  organization_id: string;
  email_recipients: string[];
  actions: ContinuousMonitoringAction[];
}

export interface UpdateConfigurationResponse {
  success: boolean;
  configuration: ContinuousMonitoringConfiguration;
}

/**
 * Get organization's continuous monitoring configurations
 */
export const getContinuousMonitoringConfigurations = async () => {
  return get<GetConfigurationsResponse>({
    url: '/v0/tpra/continuous-monitoring-configurations',
    isAuthRequired: true,
  });
};

/**
 * Save/Update a continuous monitoring configuration
 */
export const updateContinuousMonitoringConfiguration = async (
  configurationId: string,
  payload: UpdateConfigurationPayload
) => {
  return post<UpdateConfigurationPayload, UpdateConfigurationResponse>({
    url: `/v0/tpra/continuous-monitoring-configurations/${configurationId}`,
    data: payload,
    isAuthRequired: true,
  });
};
